import { Fragment, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
//constants
import { DashboardPages, pagesEnum } from 'constants/ui.constants';
// @mui
import { Stack } from '@mui/system';
// components
import { Page } from 'theme/elements/Page';
import { CenteredNarrowContent } from 'theme/elements/Content';
import CancelDialog from 'components/CancelDialog';
import Stepping from 'theme/elements/Stepper';
// sections
import CreateHeader from 'sections/convert/upsert/CreateHeader';
import Step1 from './steps/step1';
import Step2 from './steps/step2';
import Step3 from './steps/step3';
import Step4 from './steps/step4';
// reducers
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import {
  toggleUpserting,
  getSteps,
  getActiveStep,
  intializeConvert,
  getConvertById,
  setActiveStep,
} from 'state/reducers/convert.reducers';
import {
  cancelDialogProps,
  getHistory,
  getMobile,
  getUi,
  ifPageChange,
  setCheckBeforeNavigate,
  togglePage,
} from 'state/reducers/ui.reducers';
import MobileNavbar from 'sections/layout/MobileNavbar';
import { convertSteps } from 'constants/convert.constants';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getUrlBack } from 'theme/elements/Headers';
import { translatedCancelPopup } from 'utils';
import { getUserPermission } from 'state/reducers/user.reducers';

export default function ConvertSteps() {
  const navigate = useNavigate();
  const t = useAppSelector(selectTranslations);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  //get location
  const paths = location.pathname.split('/');
  const lastPath = paths[paths.length - 1];
  const found = useAppSelector(getConvertById(lastPath));
  const steps = useAppSelector(getSteps);
  const isMobile = useAppSelector(getMobile);
  const activeStep = useAppSelector(getActiveStep);
  const isLeavingPage = useAppSelector(ifPageChange);
  const ui = useAppSelector(getUi);
  const history = useAppSelector(getHistory);
  const urlback = getUrlBack(location.pathname, history[history.length - 1]);
  const stepProps = {
    handleCancel: () => setOpenCancelDialog(true),
  };
  const dialogProps = useAppSelector(cancelDialogProps);
  const dialogPropsTranslated = useMemo(() => translatedCancelPopup(dialogProps), [dialogProps]);
  const userPermission = useAppSelector(getUserPermission);

  useEffect(() => {
    //in case user don't have permission nav to homepage
    const convertPage = _.find(DashboardPages, { name: pagesEnum.CONVERT })
    if (convertPage && userPermission && !convertPage?.userPermission?.includes(userPermission)) {
      navigate(`/${pagesEnum.DASHBOARD}`);
    }
  }, [userPermission]);

  useEffect(() => {
    let flag = activeStep > 0 && activeStep < 2 ? true : false;
    dispatch(setCheckBeforeNavigate(flag));
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(() => {
    if (isLeavingPage && ui.checkBeforeNavigate) {
      setOpenCancelDialog(true);
    }
  }, [isLeavingPage]);

  useEffect(() => {
    if (!_.isEqual(lastPath, 'new')) {
      if (found) {
        dispatch(intializeConvert(found));
      } else {
        navigate('/404');
      }
    }
  });

  return (
    <Fragment>
      <MobileNavbar
        handleBack={() => {
          if (activeStep > 0 && activeStep < 2) {
            dispatch(setActiveStep(_.values(convertSteps)[activeStep - 1]));
          } else {
            dispatch(togglePage(urlback));
          }
        }}
        handleCancel={() => {
          setOpenCancelDialog(true);
        }}
      />
      <Page>
        <Stack spacing={{ sm: 5, xs: 1 }}>
          {!isMobile && <CreateHeader />}
          <Stack spacing={{ sm: 5, xs: 1 }}>
            <Stepping activeStep={activeStep} total={steps} stepsPrefix={'page.convert.create.step'} />
            <CenteredNarrowContent>
              <Fragment>
                {_.isEqual(activeStep, 0) && <Step1 {...stepProps} />}
                {_.isEqual(activeStep, 1) && <Step2 {...stepProps} />}
                {_.isEqual(activeStep, 2) && <Step3 {...stepProps} />}
                {_.isEqual(activeStep, 3) && <Step4 />}
              </Fragment>
            </CenteredNarrowContent>
          </Stack>
          <CancelDialog
            open={openCancelDialog}
            {...dialogPropsTranslated}
            handleContinue={() => {
              setOpenCancelDialog(false);
              if (isLeavingPage) {
                dispatch(togglePage());
              }
            }}
            handleCancel={() => {
              setOpenCancelDialog(false);
              dispatch(toggleUpserting(false));
              if (!isLeavingPage) {
                navigate(`/${pagesEnum.CONVERT}/new`);
              } else {
                navigate(ui.to);
              }
            }}
          />
        </Stack>
      </Page>
    </Fragment>
  );
}
